var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"template-info"},[_c('v-row',{staticClass:"mt-0 mb-0"},[_c('v-col',{staticClass:"col-12 col-sm-6"},[_vm._v("Получатели")]),_c('v-col',{staticClass:"col-12 col-sm-6 template-info__value"},[_c('ul',_vm._l((_vm.data.emails),function(item){return _c('li',{key:item},[_vm._v(_vm._s(item))])}),0)])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }